import styled from "styled-components";
import { Modal, ModalTitle, ModalBody } from "@vds/modals";
import Qualification from "pages/Qualification";
import { Trans, useTranslation } from "react-i18next";

function CheckAvailabilityModal(props) {
    return (
        <CheckAvailabilityModalWrapper
            opened={props?.opened}
            onOpenedChange={props?.onOpenedChange}
        >
            <LQModalBody>
            {/* <StyledModalTitle>
                <TitleLockup
                    data={{
                        title: {
                            bold: true,
                            size: "titleLarge",
                            children: aemContent?.loopQual?.checkAvailability?.heading ,
                        },
                        subtitle: {
                            size: "titleMedium",
                            children: <Body primitive="h4" size="large">{aemContent?.loopQual?.checkAvailability?.subHeading}</Body>,
                        }
                    }}
                />
                <MarginSpacerXL />
            </StyledModalTitle> */}
                <Qualification checkAvailability={true}/>
            </LQModalBody>
        </CheckAvailabilityModalWrapper>
    )
}

const LQModalBody = styled(ModalBody)`
  padding: 0 0px 0;
  outline: none !important;
  height: auto;
`;

const CheckAvailabilityModalWrapper = styled(Modal)`
width:560px;
height:95vh;
max-height:100vh;
.header_wrapper{
  position:relative;
  top:25px;
}
[class^=StyledHeader-VDS]{
  padding-right:0px !important;
}
[class^=Wrapper-VDS]{
  height:100% !important;
}
[class^=Wrapper-VDS]>div{
  height:100% !important;
}
[class^="StyledHeader-VDS"] {
  padding-right: 1rem !important;
}
`;

export default CheckAvailabilityModal;
